import { atom } from 'recoil';

import { BALANCE } from 'store/constants';

export const ABalance = atom<string>({
  key: BALANCE,
  default: '0',
});
